import { useEffect } from 'react';
import usePaymentConfig from '../../hooks/usePaymentConfig';

/**
 * Base Barion Pixel (csalásmegelőzés). A Barion-elfogadóhely jóváhagyásának feltétele, minden oldalon.
 * Jogalap: a Barion jogos érdeke (csalásmegelőzés) — ezért nem a süti-hozzájáruláshoz kötött; az
 * adatkezelési tájékoztató és a süti-tájékoztató ismerteti. A marketing célú „Full Pixel” eseményeket
 * NEM küldjük. Az azonosító a backend `BARION_PIXEL_ID` env-jéből jön (GET /api/payments/config).
 */
const PIXEL_ID_PATTERN = /^BP-[A-Za-z0-9]{10}-\d{2}$/;

const BarionPixel = () => {
  const { barionPixelId } = usePaymentConfig();

  useEffect(() => {
    if (!barionPixelId || !PIXEL_ID_PATTERN.test(barionPixelId) || window.bp) return;
    window.bp = window.bp || function bp(...args) { (window.bp.q = window.bp.q || []).push(args); };
    window.bp.l = Date.now();
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://pixel.barion.com/bp.js';
    document.head.appendChild(script);
    window.barion_pixel_id = barionPixelId;
    window.bp('init', 'addBarionPixelId', barionPixelId);
  }, [barionPixelId]);

  return null;
};

export default BarionPixel;
